import './pieCat.css'; 

import { Pie, PieChart, Tooltip, Label, Cell } from 'recharts';
import { useEffect, useState, useMemo } from 'react';

import CategoryIcons from '../../../assets/categoryIcons/categoryIcons';
import Swatch from '../../../assets/icons/swatch/swatch';



export default function PieCat({analyticsTime, filteredCategories}) {

    const [totalCategories, setTotalCategories] = useState(filteredCategories?.[0]?.length || 0);

    const [totalCategoriesAmount, setTotalCategoriesAmount] = useState(Math.round(filteredCategories?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0)));

    const [categoryActive, setCategoryActive] = useState([
        [filteredCategories?.[0]?.[0]?.expense_name], 
        [Math.round(((filteredCategories?.[0]?.[0]?.expense_amount) / totalCategoriesAmount) * 100)], 
        [filteredCategories?.[0]?.[0]?.expense_amount],
        [filteredCategories?.[0]?.[0]?.expense_svg_color]
    ]);

    


    const startUpTotalExpenses = useMemo(() => {
        setTotalCategories(filteredCategories?.[analyticsTime]?.length || 0);
        setTotalCategoriesAmount(Math.round(filteredCategories?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0)));
    
        setCategoryActive([
            [filteredCategories?.[analyticsTime]?.[0]?.expense_name],
            [Math.round(((filteredCategories?.[analyticsTime]?.[0]?.expense_amount) / totalCategoriesAmount) * 100)],
            [filteredCategories?.[analyticsTime]?.[0]?.expense_amount],
            [filteredCategories?.[analyticsTime]?.[0]?.expense_svg_color]
        ]);

    }, [filteredCategories]);

    useEffect(() => {

        setTotalCategories(filteredCategories?.[analyticsTime]?.length || 0);
        setTotalCategoriesAmount(Math.round(filteredCategories?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0)));
    
        const futureTotal = Math.round(filteredCategories?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0));

        setCategoryActive([
            [filteredCategories?.[analyticsTime]?.[0]?.expense_name],
            [Math.round((((filteredCategories?.[analyticsTime]?.[0]?.expense_amount) / futureTotal) * 100))],
            [filteredCategories?.[analyticsTime]?.[0]?.expense_amount],
            [filteredCategories?.[analyticsTime]?.[0]?.expense_svg_color]
        ]);

    }, [analyticsTime]);

    return(
        <div className="piecat card">
            <div className="piecat-container">
                <div className="piecat-chart">
                    <PieChart width={200} height={200}>
                    <Pie data={filteredCategories[analyticsTime]} dataKey="expense_amount" outerRadius={80} innerRadius={60} cornerRadius={100} paddingAngle={2}
                    onClick={(entry, index) => {
                        setCategoryActive([
                            [filteredCategories?.[analyticsTime]?.[index]?.expense_name],
                            [Math.round((((filteredCategories?.[analyticsTime]?.[index]?.expense_amount) / totalCategoriesAmount) * 100))],
                            [filteredCategories?.[analyticsTime]?.[index]?.expense_amount],
                            [filteredCategories?.[analyticsTime]?.[index]?.expense_svg_color]
                        ]);
                    }}
                    >
                        {filteredCategories[analyticsTime].map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.expense_svg_color} />
                        ))}
                                <Label
                                    content={({ viewBox }) => {
                                    if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                        return (
                                        <text
                                            x={viewBox.cx}
                                            y={viewBox.cy}
                                            textAnchor="middle"
                                            dominantBaseline="middle"
                                        >
                                            <tspan
                                            x={viewBox.cx}
                                            y={viewBox.cy}
                                            className="fill-foreground text-3xl font-bold"
                                            >
                                            {`${totalCategories}`}
                                            </tspan>
                                            <tspan
                                            x={viewBox.cx}
                                            y={(viewBox.cy || 0) + 24}
                                            className="fill-muted-foreground"
                                            >
                                            {`$${totalCategoriesAmount}`}
                                            </tspan>
                                        </text>
                                        )
                                    }
                                    }}
                                />

                    </Pie>
                    </PieChart>
                    
                    <div className="pie-chart-label">
                        <div className="pie-chart-label-title">
                            <Swatch swatch={categoryActive[3]}/>
                            <p>{categoryActive[0]}</p>
                        </div>
                        <strong>{`${categoryActive[1]}%`}</strong>
                        <strong>{`$${categoryActive[2]}`}</strong>
                    </div>
                </div>
                <div>
                    <div className="categorized-expenses-body-pie scroll-container">
                        {filteredCategories[analyticsTime]?.map((item, index) => {
                            return (
                            <div key={index} className="categorized-expenses-list">
                                <div className="categorized-expenses-list-head-analytics">
                                    <CategoryIcons indexIcon={item.expense_svg_icon} expenseColor={item.expense_svg_color} className=''/>
                                    <div className="categorized-expenses-list-head-analytics-body">
                                    <p>{item.expense_name}:</p>
                                    <strong>{((item.expense_amount / totalCategoriesAmount) * 100) | 0}%</strong>
                                    </div>
                                </div>              
                            </div>
                        )})}
                    </div>
                </div>
            </div>
        </div>
    )
}